module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Multiview2.71ddb3c9.jpg";